import type { DeathMarker } from '@game/scenes/characterPrototype/types';

export function saveDeathMarker(storageKey: string, marker: DeathMarker): void {
	try {
		const stored = localStorage.getItem(storageKey);
		const markers: DeathMarker[] = stored ? JSON.parse(stored) : [];

		// Remove existing markers with the same height (replace with new one)
		const HEIGHT_THRESHOLD = 10; // Consider markers within 10px as "same height"
		const filtered = markers.filter((m) => Math.abs(m.height - marker.height) > HEIGHT_THRESHOLD);

		// Add new marker
		filtered.push(marker);

		// Keep only last 50 markers to avoid localStorage bloat
		const trimmed = filtered.slice(-50);
		localStorage.setItem(storageKey, JSON.stringify(trimmed));
	} catch {
		// Ignore localStorage errors
	}
}

export type SpawnDeathMarkerFn = (marker: DeathMarker, worldY: number) => void;

export function loadDeathMarkers(
	storageKey: string,
	boundsAvailable: boolean,
	initialY: number,
	spawnMarker: SpawnDeathMarkerFn
): void {
	try {
		const stored = localStorage.getItem(storageKey);
		if (!stored) return;
		const markers: DeathMarker[] = JSON.parse(stored);
		if (!Array.isArray(markers) || !boundsAvailable) return;

		for (const marker of markers) {
			// Convert height back to world Y coordinate
			const worldY = initialY - marker.height;
			spawnMarker(marker, worldY);
		}
	} catch {
		// Ignore localStorage errors
	}
}


